module.exports = __webpack_public_path__ + "static/media/8.02dcda0f.jpg";